import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Header() {
  const { t } = useTranslation('createNote');

  return (
    <div className="text-center mb-12">
      <div className="flex justify-center items-center mb-6">
        <img src="/logo.svg" alt="Bitfortex" className="w-16 h-16" />
      </div>
      <h1 className="text-4xl font-bold mb-3 text-gray-800 tracking-tight">
        {t('title')}
      </h1>
      <p className="text-gray-600 text-lg max-w-2xl mx-auto">
        {t('subtitle')}
      </p>
    </div>
  );
}